import React, { useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { CalendarDaysIcon, ExternalLinkIcon, LayoutDashboardIcon, ListChecksIcon, LockIcon, LogOutIcon, SettingsIcon, SlidersHorizontalIcon } from 'lucide-react';
import { useAdminAuth } from '../../contexts/AdminAuth';
const links = [{
  to: '/admin',
  label: 'Dashboard',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/admin/agenda',
  label: 'Agenda',
  icon: CalendarDaysIcon,
  end: false
}, {
  to: '/admin/bookings',
  label: 'Boekingen',
  icon: ListChecksIcon,
  end: false
}, {
  to: '/admin/services',
  label: 'Diensten',
  icon: SlidersHorizontalIcon,
  end: false
}, {
  to: '/admin/availability',
  label: 'Instellingen',
  icon: SettingsIcon,
  end: false
}];
function LoginGate() {
  const {
    signIn
  } = useAdminAuth();
  const [code, setCode] = useState('dailycc');
  const [error, setError] = useState(false);
  return <div className="flex min-h-screen items-center justify-center bg-void px-5" data-id="element-42" data-mp="stoxazbzxcx9">
      <form onSubmit={e => {
      e.preventDefault();
      if (!signIn(code)) setError(true);
    }} className="w-full max-w-sm rounded-3xl border border-edge bg-carbon p-7" data-id="element-43" data-mp="30sowj48mu5bn">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ember text-void" data-id="element-44" data-mp="3aspheum5gthy">
          <LockIcon className="h-5 w-5" aria-hidden="true" data-id="element-45" data-mp="35rjs76rp7od6" />
        </span>
        <h1 className="mt-6 font-display text-2xl font-extrabold tracking-tightest text-chalk" data-id="element-46" data-mp="3jrufjztsuktl">
          Beheeromgeving
        </h1>
        <p className="mt-2 text-sm text-dim" data-id="element-47" data-mp="3eshrxcv3t9py">Daily Car Care planning en boekingen.</p>

        <label htmlFor="code" className="mt-7 block text-sm font-medium text-chalk" data-id="element-48" data-mp="3th49ll87edkc">
          Toegangscode
        </label>
        <input id="code" type="password" value={code} onChange={e => {
        setCode(e.target.value);
        setError(false);
      }} className={`mt-2 w-full rounded-2xl border bg-panel px-4 py-4 text-base text-chalk focus:border-ember ${error ? 'border-red-400' : 'border-edge'}`} data-id="element-49" data-mp="3ojumwdc78g07" />
        {error && <p className="mt-2 text-xs text-red-400" data-id="element-50" data-mp="eenkp79yunza">Onjuiste code.</p>}

        <button type="submit" className="mt-6 w-full rounded-2xl bg-ember px-5 py-4 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-51" data-mp="jcyuji09gyhi">
          Inloggen
        </button>
      </form>
    </div>;
}
export function AdminShell() {
  const {
    signedIn,
    signOut
  } = useAdminAuth();
  const {
    pathname
  } = useLocation();
  const current = [...links].reverse().find(link => link.end ? pathname === link.to : pathname.startsWith(link.to));
  if (!signedIn) return <LoginGate data-id="element-52" data-mp="33v36v32nompb" />;
  return <div className="app-shell flex-row bg-void" data-id="element-53" data-mp="33vv2uf060mg4">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-edge bg-carbon lg:sticky lg:top-0 lg:flex lg:h-screen lg:overflow-y-auto" data-id="element-54" data-mp="33x67eh1fpy8a">
        <div className="border-b border-edge px-6 py-6" data-id="element-55" data-mp="1pzbk6h8x72b3">
          <span className="font-display text-lg font-extrabold tracking-tightest text-chalk" data-id="element-56" data-mp="1q0wgabavutb2">Daily Car Care</span>
          <span className="mt-1 block text-[11px] uppercase tracking-[0.2em] text-dim" data-id="element-57" data-mp="1h6rjlb92innm">Beheer</span>
        </div>
        <nav aria-label="Beheernavigatie" className="flex-1 px-3 py-5" data-id="element-58" data-mp="1c86t43jmbicd">
          <ul className="space-y-1" data-id="element-59" data-mp="1c5u270vvtxn6">
            {links.map(link => {
            const Icon = link.icon;
            return <li key={link.to} data-id="element-60" data-mp="24w2liw25mo3c">
                  <NavLink to={link.to} end={link.end} className={({
                isActive
              }) => `flex items-center gap-3 rounded-xl px-3.5 py-3 text-sm transition-colors duration-200 ease-smooth ${isActive ? 'bg-panel text-ember' : 'text-dim hover:bg-panel hover:text-chalk'}`} data-id="element-61" data-mp="24x3yj62qdknp">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-62" data-mp="27fp6ucwky5yh" />
                    {link.label}
                  </NavLink>
                </li>;
          })}
          </ul>
        </nav>
        <div className="border-t border-edge px-3 py-4" data-id="element-63" data-mp="1yf97nfmvdkzf">
          <Link to="/" className="flex items-center gap-3 rounded-xl px-3.5 py-3 text-sm text-dim transition-colors duration-200 ease-smooth hover:text-chalk" data-id="element-64" data-mp="1ygu2z7h0d7yc">
            <ExternalLinkIcon className="h-5 w-5" aria-hidden="true" data-id="element-65" data-mp="2r46hcud0m9gk" />
            Naar website
          </Link>
          <button type="button" onClick={signOut} className="flex w-full items-center gap-3 rounded-xl px-3.5 py-3 text-sm text-dim transition-colors duration-200 ease-smooth hover:text-chalk" data-id="element-66" data-mp="2v35rquhimyfe">
            <LogOutIcon className="h-5 w-5" aria-hidden="true" data-id="element-67" data-mp="15pshypqmwi6w" />
            Uitloggen
          </button>
        </div>
      </aside>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col" data-id="element-68" data-mp="1aq7ujf33dlnt">
        <header className="safe-top z-30 flex h-14 shrink-0 items-center justify-between gap-3 border-b border-edge bg-void px-4 lg:hidden" data-id="element-69" data-mp="135e2ouljpuh9">
          <h1 className="truncate font-display text-lg font-extrabold tracking-tightest text-chalk" data-id="element-70" data-mp="y6avp4m09e6n">
            {current?.label ?? 'Beheer'}
          </h1>
          <span className="flex shrink-0 items-center gap-1.5" data-id="element-71" data-mp="176zba3r1rmln">
            <Link to="/" aria-label="Naar website" className="flex h-9 w-9 items-center justify-center rounded-full bg-panel text-dim active:text-ember" data-id="element-72" data-mp="175ee06dclpk3">
              <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="fei5tj28g935" />
            </Link>
            <button type="button" onClick={signOut} aria-label="Uitloggen" className="flex h-9 w-9 items-center justify-center rounded-full bg-panel text-dim active:text-ember" data-id="element-74" data-mp="t9kh6lpumqnc">
              <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="3ryhtnn72hci4" />
            </button>
          </span>
        </header>

        <main className="app-scroll" data-id="element-76" data-mp="1vu23im5dcenu">
          <Outlet data-id="element-77" data-mp="20togqvl75uwn" />
        </main>

        <nav aria-label="Beheernavigatie" className="safe-bottom z-40 flex shrink-0 items-center justify-around border-t border-edge bg-void px-2 pt-2 lg:hidden" data-id="element-78" data-mp="20swj7f81hn3q">
          {links.map(link => {
          const Icon = link.icon;
          return <NavLink key={link.to} to={link.to} end={link.end} aria-label={link.label} className="flex flex-1 items-center justify-center pb-2" data-id="element-79" data-mp="1cw8zfgj0dyov">
                {({
              isActive
            }) => <span className={`flex h-11 w-11 items-center justify-center rounded-2xl transition-colors duration-200 ease-smooth ${isActive ? 'bg-ember text-void' : 'text-dim'}`} data-id="element-80" data-mp="1qvigsjiyayuf">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-81" data-mp="328ue0bk7gj7m" />
                  </span>}
              </NavLink>;
        })}
        </nav>
      </div>
    </div>;
}